import type { IconType } from "react-icons/lib";
import { Link } from "react-router-dom";
import styles from "src/components/elements/BottomNavigationBarItem/bottomNavigationBarItem.module.css";

type BottomNavigationBarItemProps = {
    currentPage: string;
    setCurrentPage: (currentPage: string) => void;
    iconPath: string | IconType;
    label: string;
    pagePath: string;
};

const BottomNavigationBarItem: React.FC<BottomNavigationBarItemProps> = (
    props
) => {
    return (
        <li>
            <Link
                to={props.pagePath}
                className={`${styles.op6} ${
                    props.currentPage === props.pagePath
                        ? styles.active
                        : styles.inactive
                }`}
                onClick={() => {
                    return props.setCurrentPage(props.pagePath);
                }}
            >
                {typeof props.iconPath === "string" ? (
                    <img
                        src={props.iconPath}
                        alt="home_icon"
                        className={styles.navigation_icon_img}
                        decoding="async"
                        loading="lazy"
                    />
                ) : (
                    <props.iconPath
                        className={styles.navigation_icon_img}
                        size="1.5rem"
                    />
                )}
                <p>{props.label}</p>
            </Link>
        </li>
    );
};

export default BottomNavigationBarItem;
